import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { HorarioService } from 'src/app/services/horario.service';
import FileSaver, { saveAs } from 'file-saver';

@Component({
  selector: 'app-usuarios-xhorario',
  templateUrl: './usuarios-xhorario.component.html',
  styleUrls: ['./usuarios-xhorario.component.scss'],
})
export class UsuariosXHorarioComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  public hoy = new Date();

  constructor(
    private horarioSvc: HorarioService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UsuariosXHorarioComponent>
  ) {
    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = ['nombre', 'disciplina', 'fecha', 'estado'];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }

  ngOnInit(): void {
    this.getListadoDeportistasxHorario();
  }

  getListadoDeportistasxHorario() {
    this.horarioSvc.getDeportistasHorario(this.data.id).subscribe((result) => {
      console.log(result);
      this.dataSource = new MatTableDataSource<any>(result);
      this.isLoadingResults = false;
    });
  }

  validarFechas(fecha: any): boolean {
    return Date.parse(fecha) >= this.hoy.getTime();
  }

  descargarReporte() {
    this.horarioSvc.downloadDeportistasHorario(this.data.id || '').subscribe((result) => {
      console.log('result: ', result);

      let blob = new Blob([result], { type: 'application/vnd.ms-excel' });

      var downloadURL = window.URL.createObjectURL(result);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download =  'usuariosXHorario' + '.xlsx';
      link.click();
    });
  }


}
